import React from "react";
import { Link } from "react-router-dom";
import Button from "../../../components/common/Button";
import { useAuth } from "../../../context/AuthContext";

const CTASection = () => {
  const { user } = useAuth();
  const isLoggedIn = !!user;

  return (
    <section className="bg-gradient-to-r from-charcoal to-gray-800 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {isLoggedIn ? (
          <>
            <h2 className="text-3xl font-bold text-ivory mb-4">
              {user.name ? `${user.name}님, 환영합니다` : "환영합니다"}
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              지금 바로 부고를 작성하거나 화환을 주문해보세요
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Link to="/obituaries/create">
                <Button variant="primary" size="lg">
                  부고 작성하기
                </Button>
              </Link>
              <Link to="/wreaths">
                <Button variant="secondary" size="lg">
                  화환 주문하기
                </Button>
              </Link>
            </div>
          </>
        ) : (
          <>
            <h2 className="text-3xl font-bold text-ivory mb-4">
              지금 바로 시작하세요
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              간편한 부고 작성과 화환 주문을 경험해보세요
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Link to="/signup">
                <Button variant="primary" size="lg">
                  회원가입하기
                </Button>
              </Link>
              <Link
                to="/login"
                className="text-gray-200 underline-offset-4 hover:text-ivory hover:underline transition-colors"
              >
                이미 회원이신가요? 로그인
              </Link>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default CTASection;
